/* Maison Alméa — 17/09/2026 perf : sorti de snippets/nautiya-product-enhance.liquid (etait colle dans chaque fiche produit). */

(function () {
  /* 18/09/2026 : interrupteur ?noenh=1 (diagnostic) — etait dans le loader de layout/theme.liquid, desormais ici
     car le script est rendu en synchrone en fin de section produit (avant le marqueur du voile). */
  if (/[?&]noenh=1/.test(location.search)) { try { document.documentElement.setAttribute('data-nty-enh', 'off'); } catch (e) {} return; }
  var MOBILE = function () { return window.matchMedia('(max-width: 768px)').matches; };
  var NTY_ACCENT = '#1a1a1a';

  var NTY_PROD = (function () {
    try { var el = document.getElementById('nty-prod-json'); return el ? JSON.parse(el.textContent) : {}; }
    catch (e) { return {}; }
  })();

  var NTY_VARIANTS = (function () {
    try { var el = document.getElementById('nty-variants-json'); return el ? JSON.parse(el.textContent) : []; }
    catch (e) { return []; }
  })();

  function imgFilename(url) {
    if (!url) return '';
    var u = String(url).split('?')[0].split('#')[0];
    var seg = u.split('/');
    return seg[seg.length - 1].toLowerCase();
  }

  /* Données couleurs codées par handle paddle (Nautiya) supprimées :
     aucune ne correspond à un produit Lumiverra. Fallback = objet vide
     (les pastilles couleur restent masquées tant qu'aucun handle ne matche). */
  var COLOR_MAP = {};

  /* Tailles codées par handle paddle (Nautiya) supprimées : vide/fallback. */
  var SIZE_MAP = {};

  /* ============================================================================
     T15 — CONTENU DU PACK (features-bar) par produit.
     Icones SVG ligne raffinees (GONG-style) : stroke currentColor, fill none,
     viewBox 0 0 24 24, stroke-width 1.5, linecap/linejoin round.
     PACK_MAP: handle -> liste ordonnee {label FR, icon}. Aucun item invente.
     ============================================================================ */
  var PACK_ICONS = {
    planche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2c2.5 0 4 4.5 4 10s-1.5 10-4 10-4-4.5-4-10S9.5 2 12 2z"/><line x1="12" y1="9" x2="12" y2="15"/></svg>',
    kayak:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12c4-1.5 16-1.5 20 0-4 1.5-16 1.5-20 0z"/><path d="M8.5 11h7M9.5 13h5"/></svg>',
    pagaie:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 9.5c2.2 0 3.5 2 3.5 4.5S14.2 18 12 18s-3.5-1.5-3.5-4S9.8 9.5 12 9.5z"/><line x1="12" y1="9.5" x2="12" y2="2"/></svg>',
    aileron: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19c0-7 4.5-13 13-15-1 8.5-4.5 13-9.5 15-1 .4-3.5.4-3.5 0z"/></svg>',
    leash:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 6.5c0-2 3-2 3 0s-3 2-3 4 3 2 3 4-3 2-3 4"/><circle cx="16.5" cy="17" r="3.5"/></svg>',
    sacetanche: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7 8h10M8 8l1-2.5h6L16 8M7 8v11a2 2 0 002 2h6a2 2 0 002-2V8"/><path d="M9 5.5h6"/></svg>',
    sangle:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 19L17 5"/><rect x="15" y="3.5" width="5.5" height="4" rx="1"/><rect x="3.5" y="16.5" width="5.5" height="4" rx="1"/></svg>',
    pompe:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="10" width="6" height="11" rx="1.5"/><line x1="12" y1="10" x2="12" y2="4"/><line x1="8.5" y1="4" x2="15.5" y2="4"/><path d="M15 8h4v4"/></svg>',
    sac:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="6.5" y="7" width="11" height="14" rx="2.5"/><path d="M9.5 7V5.5a2.5 2.5 0 015 0V7"/><line x1="9.5" y1="12" x2="14.5" y2="12"/></svg>',
    siege:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M7 5v9a2 2 0 002 2h6"/><path d="M7 16v3M15 16v3"/><path d="M7 11h6"/></svg>',
    kit:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="8" width="16" height="11" rx="2"/><path d="M9 8V6.5a2 2 0 012-2h2a2 2 0 012 2V8"/><line x1="12" y1="11" x2="12" y2="16"/><line x1="9.5" y1="13.5" x2="14.5" y2="13.5"/></svg>'
  };

  /* Contenu du pack codé par handle paddle (Nautiya) supprimé : aucun de ces
     handles ne correspond à un produit Lumiverra. Fallback = objet vide.
     Tant que PACK_MAP est vide, la barre "What is included" reste intacte
     (enhanceFeaturesBar ne remplace rien pour un handle inconnu). */
  var PACK_MAP = {};

  
  /* ============================================================================
     ===== AVIS — ETAT VIDE HONNETE (2026-07-30).                            =====
     ===== Les 6 avis de DEMONSTRATION (noms, titres, textes, notes et dates  =====
     ===== inventes) ainsi que la moyenne, le compteur "24 avis" et les       =====
     ===== barres de repartition 5*->1* ont ete SUPPRIMES : Maison Almea n'a  =====
     ===== AUCUN avis en base. Plus aucune note ni aucun nombre n'est simule. =====
     ===== POUR REBRANCHER LES VRAIS AVIS : alimenter NTY_REVIEW_COUNT,       =====
     ===== NTY_REVIEW_AVG et NTY_REVIEWS depuis les metafields produit        =====
     ===== reviews.rating / reviews.rating_count (les memes que ceux lus par  =====
     ===== snippets/nautiya-card-rating.liquid), ou depuis l'API de l'app     =====
     ===== d'avis. Les deux fonctions en aval (enhanceReviewsLine et          =====
     ===== buildReviewsSection) rebasculent alors seules sur l'affichage      =====
     ===== chiffre, sans autre modification.                                 =====
     ===== Reversible : assets/backup-20260730-nautiya-product-enhance.liquid.txt
     ============================================================================ */
  var NTY_REVIEWS = [];
  var NTY_REVIEW_COUNT = 0;
  var NTY_REVIEW_AVG = 0;
  var NTY_HAS_REVIEWS = (NTY_REVIEWS.length > 0 && NTY_REVIEW_COUNT > 0);
  /* ===== FIN BLOC AVIS — etat vide, aucune donnee de demonstration ===== */

  function starStr(n, full) {
    full = (typeof full === 'number') ? full : 5;
    var f = Math.round(n), out = '';
    for (var i = 0; i < full; i++) out += (i < f) ? '★' : '☆';
    return out;
  }

  function currentHandle() {
    var m = (window.location.pathname || '').match(/\/products\/([^\/\?#]+)/);
    return m ? decodeURIComponent(m[1]).toLowerCase() : '';
  }

  function enhanceGallery() {
    var wrap = document.querySelector('[id^="mzMainImgWrap-"]');
    if (!wrap) return;
    var imgs = wrap.querySelectorAll('img[class*="mz-main-img-"]');
    if (!imgs.length) return;
    if (!wrap.dataset.ntyCarousel) {
      var fresh = wrap.cloneNode(true);
      wrap.parentNode.replaceChild(fresh, wrap);
      wrap = fresh; wrap.dataset.ntyCarousel = '1';
    }
    wrap.classList.add('nty-carousel');
    var nativeDots = wrap.querySelector('[id^="mzDots-"]') || document.querySelector('[id^="mzDots-"]');
    /* 31/08 — en mobile la bande de miniatures (.nty-thumbstrip) est masquee par le
       theme ; masquer AUSSI les dots natifs ne laissait aucun reperage a l'ecran.
       On ne les masque donc qu'a partir de 769px. Desktop : inchange. */
    var ntyDesktop = window.matchMedia('(min-width: 769px)').matches;
    /* 31/08 : en mobile on SORT les dots du wrap. Le wrap est le conteneur de
       defilement du carrousel : un enfant (meme absolu) y defile avec les images
       et n'etait donc visible que sur la premiere. On les pose juste dessous. */
    if (nativeDots && !ntyDesktop && nativeDots.parentNode === wrap) {
      if (wrap.nextSibling) { wrap.parentNode.insertBefore(nativeDots, wrap.nextSibling); }
      else { wrap.parentNode.appendChild(nativeDots); }
    }
    if (nativeDots) { nativeDots.classList.toggle('nty-hidden', ntyDesktop); }
    imgs = wrap.querySelectorAll('img[class*="mz-main-img-"]');
    var galleryCol = wrap.closest('[id^="mzGalleryCol-"]') || wrap.parentNode;
    var strip = galleryCol.querySelector('.nty-thumbstrip');
    if (!strip) {
      strip = document.createElement('div'); strip.className = 'nty-thumbstrip'; strip.setAttribute('role', 'tablist');
      if (wrap.nextSibling) { wrap.parentNode.insertBefore(strip, wrap.nextSibling); } else { wrap.parentNode.appendChild(strip); }
    }
    function setActive(idx) {
      var btns = strip.querySelectorAll('.nty-thumbstrip__btn');
      btns.forEach(function (b, i) { b.classList.toggle('is-active', i === idx); });
      /* 02/11 (Lancelot : « la 3D directement dans le carrousel, en 2e ») : idx = -1 = la diapo 3D (snippets/almea-voir-chez-moi), sa vignette .alm-3ds-th s'allume. RETOUR : retirer cette ligne et les 2 autres marquees 02/11 de ce bloc. */
      var th3 = strip.querySelector('.alm-3ds-th'); if (th3) th3.classList.toggle('is-active', idx === -1);
      /* 31/08 : on memorise l'index voulu — il sert de reference au gardien
         qui empeche un autre script de remettre le point sur la 1re image. */
      wrap.dataset.ntyIdx = String(idx);
      /* 31/08 : les dots natifs (mobile) suivent le carrousel.
         03/09 : le point actif est porte par l'attribut data-nty-on, que SEUL ce
         script ecrit. La classe .active, que la section remet sur la 1re image
         de la variante a chaque clic de couleur, n'a plus d'effet visuel en
         mobile (CSS ci-dessus) : plus besoin de gardien ni de resynchronisation. */
      if (nativeDots) {
        nativeDots.querySelectorAll('[class*="mz-dot-"]').forEach(function (d, i) {
          if (i === idx) { d.setAttribute('data-nty-on', '1'); } else { d.removeAttribute('data-nty-on'); }
          d.classList.toggle('active', i === idx);
        });
      }
      var active = idx === -1 ? th3 : btns[idx];
      if (active && typeof active.scrollIntoView === 'function') {
        try { active.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' }); }
        catch (e) { strip.scrollLeft = active.offsetLeft - (strip.clientWidth / 2) + (active.clientWidth / 2); }
      }
    }
    if (strip.dataset.count !== String(imgs.length)) {
      strip.innerHTML = '';
      imgs.forEach(function (img, i) {
        var b = document.createElement('button'); b.type = 'button';
        b.className = 'nty-thumbstrip__btn' + (i === 0 ? ' is-active' : ''); b.dataset.index = String(i);
        var t = document.createElement('img'); t.loading = 'lazy'; t.decoding = 'async'; (function (t, u) { /* 30/09 perf : vignettes posées juste APRÈS le 1er affichage (avant : 7 vignettes téléchargées avant la grande photo) ; 120 px suffisent sauf écran très dense */ var go = function () { if (t.__almV) return; t.__almV = 1; if (/width=\d+/.test(u)) { t.sizes = '54px'; t.srcset = u.replace(/([?&])width=\d+/, '$1width=120') + ' 120w, ' + u.replace(/([?&])width=\d+/, '$1width=160') + ' 160w'; } t.src = u.replace(/([?&])width=\d+/, '$1width=160'); }; if (document.getElementById('almea-render-barrier') && document.readyState === 'loading') { try { requestAnimationFrame(function () { setTimeout(go, 0); }); } catch (e) {} setTimeout(go, 1500); } else { go(); } })(t, ((img.dataset && img.dataset.src) || img.getAttribute('src') || img.currentSrc || img.src || '')); t.alt = img.alt || ''; /* 25/09/2026 : 160 px suffisent (vignette de 54 px, meme sur ecran x3). 12/09/2026 perf : vignettes en 240 px au lieu de la photo pleine taille (10 x ~80 Ko economises) */
        b.appendChild(t);
        b.addEventListener('click', function () { var target = imgs[i]; if (target) { wrap.scrollTo({ left: target.offsetLeft, behavior: 'smooth' }); } setActive(i); });
        strip.appendChild(b);
      });
      strip.dataset.count = String(imgs.length);
    }
    /* 31/08 : rendre les dots natifs cliquables sur le carrousel mobile */
    if (nativeDots && !nativeDots.dataset.ntyBound) {
      nativeDots.addEventListener('click', function (ev) {
        var d = ev.target.closest('[class*="mz-dot-"]');
        if (!d) return;
        var i = parseInt(d.getAttribute('data-index') || '0', 10);
        var target = imgs[i];
        if (!target) return;
        ev.preventDefault(); ev.stopPropagation();
        wrap.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        setActive(i);
      }, true);
      nativeDots.dataset.ntyBound = '1';
    }
    /* 03/09 — UN SEUL CONTROLEUR DES POINTS (remplace : ecouteur scroll +
       IntersectionObserver + MutationObserver « gardien » + 3 minuteries a
       CHAQUE clic sur la page, qui se contredisaient et faisaient sauter les
       points pendant le glissement).
       Source de verite : la position de defilement, lue au plus une fois par
       image (requestAnimationFrame), convertie en rang parmi les images
       VISIBLES (le filtre de variante en masque une partie), puis en index reel.
       Aucune lecture de style pendant le geste : la liste des images visibles
       est mise en cache et n'est recalculee qu'apres un clic de variante. */
    var visCache = null;
    function imagesVisibles() {
      if (visCache) return visCache;
      var v = [];
      /* 02/11 : les diapos du carrousel = les photos + la diapo 3D (.alm-3ds), dans l'ordre de l'ecran. RETOUR : remettre la boucle sur imgs seules. */
      var sl = wrap.querySelectorAll('img[class*="mz-main-img-"], .alm-3ds');
      for (var k = 0; k < sl.length; k++) {
        if (getComputedStyle(sl[k]).display !== 'none') v.push(sl[k]);
      }
      visCache = v;
      return v;
    }
    var dernierIdx = -1;
    function syncFromScroll(force) {
      var vis = imagesVisibles();
      if (!vis.length) return;
      var w = wrap.clientWidth || 1;
      var rang = Math.round(wrap.scrollLeft / w);
      if (rang < 0) rang = 0;
      if (rang > vis.length - 1) rang = vis.length - 1;
      var reel = vis[rang].classList.contains('alm-3ds') ? -1 : Array.prototype.indexOf.call(imgs, vis[rang]);
      if (reel < 0 && !vis[rang].classList.contains('alm-3ds')) reel = 0;
      if (!force && reel === dernierIdx) return;   /* rien n'a change : on ne touche pas au DOM */
      dernierIdx = reel;
      setActive(reel);
    }
    if (!wrap.dataset.ntyScroll) {
      var raf = null, fin = null;
      wrap.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = null; syncFromScroll(false); });
        /* filet de fin de geste (scrollend n'existe pas partout) */
        if (fin) clearTimeout(fin);
        fin = setTimeout(function () { fin = null; syncFromScroll(false); }, 120);
      }, { passive: true });
      /* clic de variante : le filtre change la liste des images visibles
         (feuille de style reecrite dans la meme passe puis a 120 ms) */
      document.addEventListener('click', function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (!t.closest('[class*="mz-variant-btn-"],[class*="mz-color-swatch"],[class*="alm-dot"]')) return;
        visCache = null;
        setTimeout(function () { visCache = null; syncFromScroll(true); }, 0);
        setTimeout(function () { visCache = null; syncFromScroll(true); }, 160);
      }, true);
      window.addEventListener('resize', function () { visCache = null; }, { passive: true });
      /* 02/11 : la diapo 3D vient d'etre posee, deplacee ou cachee : on recompte les diapos */
      wrap.addEventListener('alm:diapos', function () { visCache = null; syncFromScroll(true); });
      wrap.dataset.ntyScroll = '1';
      syncFromScroll(true);
    }
  }

  /* ============================================================================
     T4c — CLIC sur un dot couleur => image variante dans le carrousel principal.
     Donnees REELLES depuis #nty-variants-json (variantes Liquid dans l'ordre).
     Match par NOM DE FICHIER de l'image (dernier segment, sans query) entre la
     variante et un slide <img class*="mz-main-img-"> ; on active ce slide via le
     mecanisme existant (display inline des slides + scroll du carrousel + dots +
     thumbstrip). Fallback : on remplace le src de l'image principale visible.
     Bind unique via listener delegue garde par un flag.
     ============================================================================ */
  function mainGalleryWrap() { return document.querySelector('[id^="mzMainImgWrap-"]'); }

  function activateSlideByFilename(fname, variantImgUrl) {
    var wrap = mainGalleryWrap();
    if (!wrap) return false;
    /* 03/09 — MOBILE : on ne fait RIEN. Les carrousels par variante sont des
       miroirs (meme nombre de photos, meme ordre) et le filtre de variante
       masque les autres : la photo equivalente de la nouvelle couleur apparait
       naturellement A LA MEME POSITION. Ce scrollTo(offsetLeft) ramenait le
       client a la 1re image a chaque changement de couleur. */
    if (wrap.classList.contains('nty-carousel') && window.matchMedia('(max-width: 768px)').matches) return true;
    var imgs = Array.prototype.slice.call(wrap.querySelectorAll('img[class*="mz-main-img-"]'));
    if (!imgs.length) return false;
    var matchIdx = -1;
    for (var i = 0; i < imgs.length; i++) {
      var cand = imgFilename(imgs[i].getAttribute('data-src') || imgs[i].currentSrc || imgs[i].getAttribute('src') || imgs[i].src);
      if (cand && fname && cand === fname) { matchIdx = i; break; }
    }
    if (matchIdx === -1) {
      /* Fallback : remplace l'image principale visible */
      var visible = null;
      for (var k = 0; k < imgs.length; k++) {
        var st = window.getComputedStyle(imgs[k]);
        if (st.display !== 'none' && imgs[k].offsetParent !== null) { visible = imgs[k]; break; }
      }
      visible = visible || imgs[0];
      if (visible && variantImgUrl) { visible.setAttribute('srcset', ''); visible.src = variantImgUrl; }
      return true;
    }
    /* Active le slide correspondant via le mecanisme existant (display inline) */
    var isCarousel = wrap.classList.contains('nty-carousel');
    imgs.forEach(function (im, i) {
      if (isCarousel) {
        /* en mode carrousel nty (mobile) les slides sont tous affiches : on scrolle */
      } else {
        im.style.display = (i === matchIdx) ? '' : 'none';
      }
    });
    if (isCarousel) {
      var target = imgs[matchIdx];
      if (target) { try { wrap.scrollTo({ left: target.offsetLeft, behavior: 'smooth' }); } catch (e) { wrap.scrollLeft = target.offsetLeft; } }
    }
    /* Thumbstrip */
    var galleryCol = wrap.closest('[id^="mzGalleryCol-"]') || wrap.parentNode;
    var strip = galleryCol ? galleryCol.querySelector('.nty-thumbstrip') : null;
    if (strip) {
      var btns = strip.querySelectorAll('.nty-thumbstrip__btn');
      btns.forEach(function (b, i) { b.classList.toggle('is-active', i === matchIdx); });
    }
    /* Dots natifs */
    var dots = wrap.querySelector('[id^="mzDots-"]') || document.querySelector('[id^="mzDots-"]');
    if (dots) {
      var dotEls = dots.children;
      for (var d = 0; d < dotEls.length; d++) {
        if (d === matchIdx) { dotEls[d].classList.add('active'); } else { dotEls[d].classList.remove('active'); }
      }
    }
    return true;
  }

  function bindSwatchImageSwap() {
    if (window.__ntySwatchSwapBound) return;
    window.__ntySwatchSwapBound = true;
    document.addEventListener('click', function (e) {
      var dot = e.target && e.target.closest ? e.target.closest('[class*="mz-color-swatch"]') : null;
      if (!dot) return;
      var container = dot.closest('[class*="mz-color-swatches"]') || dot.parentNode;
      if (!container) return;
      var dots = Array.prototype.slice.call(container.querySelectorAll('[class*="mz-color-swatch"]'));
      var idx = dots.indexOf(dot);
      if (idx === -1) return;
      /* marque visuellement le dot actif */
      dots.forEach(function (d) { d.classList.remove('nty-swatch-active'); });
      dot.classList.add('nty-swatch-active');
      var v = NTY_VARIANTS[idx];
      if (!v || !v.img) return;
      try { activateSlideByFilename(imgFilename(v.img), v.img); } catch (err) {}
    }, false);
  }

  function enhanceSwatches() {
    var container = document.querySelector('[class*="mz-color-swatches"]');
    if (!container) return;
    var block = container.closest('[class*="mz-variant-block"]');
    var handle = currentHandle(); var colors = COLOR_MAP[handle];
    var signature = handle + '|' + (colors ? colors.join(',') : 'none');
    if (container.dataset.ntySig === signature) return;
    if (!colors) {
      container.style.setProperty('display', 'none', 'important'); hideColourLabel(container);
      if (block) { block.classList.add('nty-color-hidden'); block.classList.remove('nty-color-card'); }
      container.dataset.ntySig = signature; return;
    }
    container.style.removeProperty('display');
    if (block) { block.classList.remove('nty-color-hidden'); block.classList.add('nty-color-card'); }
    var dots = Array.prototype.slice.call(container.querySelectorAll('[class*="mz-color-swatch"]'));
    if (!dots.length) { if (block) { block.classList.add('nty-color-hidden'); block.classList.remove('nty-color-card'); } container.dataset.ntySig = signature; return; }
    var template = dots[0];
    while (dots.length < colors.length) { var clone = template.cloneNode(true); clone.classList.remove('active'); container.appendChild(clone); dots.push(clone); }
    while (dots.length > colors.length) { var extra = dots.pop(); if (extra && extra.parentNode) extra.parentNode.removeChild(extra); }
    dots.forEach(function (dot, i) { var hex = colors[i]; dot.style.setProperty('background', hex, 'important'); dot.style.setProperty('background-color', hex, 'important'); dot.setAttribute('title', hex); dot.setAttribute('aria-label', 'Colour ' + (i + 1)); });
    hideColourName(container); container.dataset.ntySig = signature;
  }

  function infoCol() { return document.querySelector('[class*="mz-product-info"]') || document.querySelector('[class*="mz-info-col"]'); }
  function withinInfo(node) { var col = infoCol(); if (!col || !node) return false; return col === node || col.contains(node); }
  function sizeAnchor() {
    var col = infoCol();
    var block = document.querySelector('[class*="mz-variant-block"]');
    if (block && (!col || withinInfo(block))) { return { ref: block, mode: 'before' }; }
    var comp = document.querySelector('[class*="mz-complements"]');
    if (comp && (!col || withinInfo(comp))) { return { ref: comp, mode: 'before' }; }
    var compItem = document.querySelector('[class*="mz-complement-item"]');
    if (compItem) {
      var node = compItem;
      if (col) { while (node && node.parentNode && node.parentNode !== col) { node = node.parentNode; } if (node && node.parentNode === col) { return { ref: node, mode: 'before' }; } }
      if (compItem.parentNode) { return { ref: compItem.parentNode, mode: 'before' }; }
    }
    var atcs = document.querySelectorAll('[class*="mz-atc"], [class*="buy_buttons"]');
    for (var i = 0; i < atcs.length; i++) {
      var a = atcs[i]; if (/sticky/i.test(a.className)) continue;
      if (!col || withinInfo(a)) {
        var n = a; if (col) { while (n && n.parentNode && n.parentNode !== col) { n = n.parentNode; } if (n && n.parentNode === col) { return { ref: n, mode: 'before' }; } }
        return { ref: a, mode: 'before' };
      }
    }
    if (col) { return { ref: col, mode: 'append' }; }
    return null;
  }
  function placeSizeBlock(el, anchor) { if (!anchor || !el) return; if (anchor.mode === 'append') { anchor.ref.appendChild(el); } else { anchor.ref.parentNode.insertBefore(el, anchor.ref); } }
  function enhanceSize() {
    var handle = currentHandle(); var size = SIZE_MAP[handle]; var existing = document.querySelector('.nty-size-block');
    if (!size) { if (existing && existing.parentNode) existing.parentNode.removeChild(existing); return; }
    var anchor = sizeAnchor(); if (!anchor) return;
    if (existing) {
      var p = existing.querySelector('.nty-size-block__pill'); if (p && p.textContent !== size) p.textContent = size;
      var misplaced = !withinInfo(existing);
      if (anchor.mode === 'before') { if (existing.nextElementSibling !== anchor.ref || existing.parentNode !== anchor.ref.parentNode || misplaced) { placeSizeBlock(existing, anchor); } }
      else { if (existing.parentNode !== anchor.ref || misplaced) { placeSizeBlock(existing, anchor); } }
      return;
    }
    var el = document.createElement('div'); el.className = 'nty-size-block';
    var label = document.createElement('span'); label.className = 'nty-size-block__label'; label.textContent = 'Size';
    var pill = document.createElement('span'); pill.className = 'nty-size-block__pill'; pill.textContent = size;
    el.appendChild(label); el.appendChild(pill); placeSizeBlock(el, anchor);
  }
  function hideColourLabel(container) { var row = findColourRow(container); if (row) row.style.setProperty('display', 'none', 'important'); }
  function hideColourName(container) {
    var row = findColourRow(container); if (!row) return;
    var spans = row.querySelectorAll('span, strong, b');
    spans.forEach(function (s) { var txt = (s.textContent || '').trim(); if (txt && !s.querySelector('*') && !/couleur/i.test(txt)) { s.style.setProperty('display', 'none', 'important'); } });
  }
  function findColourRow(container) { var node = container; for (var i = 0; i < 4 && node && node.parentNode; i++) { node = node.parentNode; if (node && /couleur/i.test(node.textContent || '')) return node; } return container.parentNode || null; }

  /* 02/09 — PASTILLE « -X % » RETIREE DE LA FICHE PRODUIT (demande de Lancelot).
     Elle s'ajoutait d'elle-meme des qu'un prix barre existait, juste au-dessus de la
     ligne d'avis. La fiche annonce deja la remise deux fois : le prix barre et le
     bandeau « Economisez X € ». Une troisieme mention alourdit et fait discount.
     On corrige a la source plutot que de la masquer en CSS, et on retire aussi
     celle qu'une passe precedente aurait pu poser.
     POUR LA REMETTRE : restaurer le corps d'origine, garde juste en dessous. */
  function enhancePromoBadge() {
    var existing = document.querySelector('.nty-promo-badge');
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
  }
  /* CORPS D'ORIGINE (avant le 02/09), conserve tel quel pour retour arriere :
     var price = Number(NTY_PROD.price); var compareAt = Number(NTY_PROD.compareAt);
     var existing = document.querySelector('.nty-promo-badge');
     var hasRealSale = isFinite(price) && isFinite(compareAt) && compareAt > 0 && compareAt > price;
     if (!hasRealSale) { if (existing && existing.parentNode) existing.parentNode.removeChild(existing); return; }
     if (existing) return;
     var pct = Math.round((compareAt - price) / compareAt * 100); if (!(pct > 0)) return;
     var badgeWrap = document.querySelector('[class*="mz-badge"]');
     var host = badgeWrap ? badgeWrap.parentNode : (infoCol() || null); if (!host) return;
     var pill = document.createElement('span'); pill.className = 'nty-promo-badge'; pill.textContent = '-' + pct + '%';
     if (badgeWrap) { host.insertBefore(pill, badgeWrap); } else { host.insertBefore(pill, host.firstChild); } */

  /* Ligne avis sous le prix. ETAT VIDE 2026-07-30 : tant que NTY_HAS_REVIEWS est
     faux, on n'affiche NI nombre NI etoiles pleines — seulement la mention
     honnete "No reviews yet", qui reste cliquable et defile jusqu'au
     bloc Avis. Aucune valeur nulle n'est concatenee : pas de NaN, pas de "0 avis"
     trompeur, pas d'etoile doree fantome. */
  function enhanceReviewsLine() {
    if (document.querySelector('.nty-reviews-line')) return;
    var priceBlock = document.querySelector('[class*="mz-price-block"]'); if (!priceBlock) return;
    var btn = document.createElement('button'); btn.type = 'button';
    btn.className = 'nty-reviews-line' + (NTY_HAS_REVIEWS ? '' : ' nty-reviews-line--empty');
    var txt = document.createElement('span'); txt.className = 'nty-reviews-line__txt';
    txt.textContent = NTY_HAS_REVIEWS ? (NTY_REVIEW_COUNT + ' reviews') : 'No reviews yet';
    btn.appendChild(txt);
    if (NTY_HAS_REVIEWS) {
      var stars = document.createElement('span'); stars.className = 'nty-reviews-line__stars'; stars.textContent = starStr(NTY_REVIEW_AVG);
      btn.appendChild(stars);
    }
    btn.addEventListener('click', function () { var sec = document.getElementById('nty-reviews'); if (sec) sec.scrollIntoView({ behavior: 'smooth' }); });
    if (priceBlock.nextSibling) { priceBlock.parentNode.insertBefore(btn, priceBlock.nextSibling); } else { priceBlock.parentNode.appendChild(btn); }
  }

  /* T15 — Remplace le contenu de .features-list par le pack reel du produit courant */
  function enhanceFeaturesBar() {
    var section = document.querySelector('[class*="features-bar-section"]'); if (!section) return;
    var list = section.querySelector('.features-list'); if (!list) return;
    var handle = currentHandle(); var pack = PACK_MAP[handle];
    if (!pack) return; /* handle inconnu : on laisse la barre existante intacte */
    if (list.dataset.ntyPack === handle) return; /* idempotent */
    while (list.firstChild) list.removeChild(list.firstChild);
    pack.forEach(function (it) {
      var label = it[0], iconKey = it[1];
      var svg = PACK_ICONS[iconKey] || '';
      var item = document.createElement('div'); item.className = 'feature-item';
      var ic = document.createElement('div'); ic.className = 'feature-icon'; ic.innerHTML = svg;
      var lb = document.createElement('span'); lb.className = 'feature-label'; lb.textContent = label;
      item.appendChild(ic); item.appendChild(lb); list.appendChild(item);
    });
    list.classList.add('nty-pack');
    list.dataset.ntyPack = handle;
  }

  function mainContentEl() { return document.getElementById('MainContent') || document.querySelector('[id*="MainContent"]') || document.querySelector('main') || document.body; }
  /* 03/09 — IDEMPOTENT. Avant, ces deux fonctions faisaient host.appendChild()
     SANS CONDITION a chaque run() : chaque appel produisait des mutations, le
     MutationObserver rappelait run() 200 ms plus tard, et la page tournait en
     boucle (10 mutations/s, main thread occupe a 85 %, tout etait saccade).
     Le garde-fou du 16/08 vivait dans la section nty-desc-settings, retiree du
     gabarit depuis : on corrige donc ICI, a la source. On ne deplace un bloc que
     s'il n'est pas deja a sa place. */
  function ensureAtEnd(sec) { var host = mainContentEl(); if (!host || !sec) return; if (sec.parentNode !== host) { host.appendChild(sec); } }
  function reanchorSections() {
    var host = mainContentEl(); if (!host) return;
    var desc = document.getElementById('mz-product-description'); var rev = document.getElementById('nty-reviews');
    if (desc && rev) {
      if (desc.parentNode === host && rev.parentNode === host && desc.nextElementSibling === rev) return;
      host.appendChild(desc); host.appendChild(rev);
    } else if (desc) { ensureAtEnd(desc); }
    else if (rev) { ensureAtEnd(rev); }
  }

  /* Bloc Avis de la fiche produit. ETAT VIDE 2026-07-30 :
     - AUCUNE carte d'avis (les 6 cartes de demonstration sont supprimees) ;
     - AUCUN en-tete d'agregat : ni moyenne, ni "Moyenne de N avis", ni barres de
       repartition 5*->1* (donc aucune barre fantome a 100 %) ;
     - AUCUNE barre d'outils (recherche / tri / pastilles) et AUCUNE liste vide :
       les conteneurs .nty-reviews__summary, __dist, __tools, __sort, __pill et
       __list ne sont plus emis du tout, donc les post-traitements de
       snippets/nautiya-enh-override.liquid (photos d'avis, tri, pastilles) et la
       pagination .nty-pg n'ont plus rien a accrocher et se desactivent seuls ;
     - a la place, UN seul bloc sobre : 5 etoiles vides grises, le titre
       "No reviews yet" et une ligne d'invitation, avec le filet
       terracotta var(--almea-cta-bg, #B0764F) de la charte Maison Almea.
     Le titre <h2> "Customer reviews" est conserve : c'est l'ancre de defilement de la
     ligne avis et de la navigation interne. */
  function buildReviewsSection() {
    if (document.getElementById('nty-reviews')) { ensureAtEnd(document.getElementById('nty-reviews')); return; }
    var sec = document.createElement('section'); sec.id = 'nty-reviews'; sec.className = 'nty-reviews nty-reviews--empty';
    sec.innerHTML = '<div class="nty-reviews__inner"><h2 class="nty-reviews__h">Customer reviews</h2><div class="nty-reviews__empty"><div class="nty-reviews__empty-stars" aria-hidden="true">☆☆☆☆☆</div><p class="nty-reviews__empty-h">No reviews yet</p><p class="nty-reviews__empty-p">Be the first to review this light.</p></div></div>';
    mainContentEl().appendChild(sec); ensureAtEnd(sec);
  }

  function buildDescription() {
    var existing = document.getElementById('mz-product-description');
    if (!existing) {
      var tpl = document.getElementById('nty-prod-desc');
      var sec = document.createElement('section'); sec.id = 'mz-product-description'; sec.className = 'nty-desc';
      var inner = document.createElement('div'); inner.className = 'nty-desc__inner';
      var h = document.createElement('h2'); h.className = 'nty-desc__h'; h.textContent = 'Description';
      var clamp = document.createElement('div'); clamp.className = 'nty-desc__clamp';
      var body = document.createElement('div'); body.className = 'nty-desc__body';
      if (tpl && 'content' in tpl) { body.appendChild(tpl.content.cloneNode(true)); }
      clamp.appendChild(body);
      var toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'nty-desc__toggle'; toggle.textContent = 'Show more';
      toggle.addEventListener('click', function () { var open = clamp.classList.toggle('is-open'); toggle.textContent = open ? 'Show less' : 'Show more'; });
      inner.appendChild(h); inner.appendChild(clamp); inner.appendChild(toggle); sec.appendChild(inner);
      mainContentEl().appendChild(sec); existing = sec;
    }
    ensureAtEnd(existing);
    /* Affiche/masque le toggle selon que le texte deborde reellement du line-clamp.
       Mesure : scrollHeight (texte complet) vs clientHeight (clampe) sur .nty-desc__body. */
    var clampEl = existing.querySelector('.nty-desc__clamp'); var bodyEl = existing.querySelector('.nty-desc__body'); var tg = existing.querySelector('.nty-desc__toggle');
    if (clampEl && bodyEl && tg && !clampEl.classList.contains('is-open')) {
      if (bodyEl.scrollHeight <= bodyEl.clientHeight + 4) { tg.style.display = 'none'; } else { tg.style.display = ''; }
    }
    var seeBtn = document.querySelector('[class*="mz-see-desc-btn"]');
    if (seeBtn && !seeBtn.dataset.ntyDesc) {
      seeBtn.dataset.ntyDesc = '1';
      seeBtn.addEventListener('click', function (e) { var target = document.getElementById('mz-product-description'); if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); } });
    }
  }

  /* 09/09 : correction du prix affiche deux fois dans la barre sticky. Cause : la
     garde dataset.ntyLabel empechait tout second passage, alors que l'app MZ
     reecrit le contenu de son bouton apres un ajout au panier / une fermeture du
     tiroir et remet son propre prix a cote de nos deux spans. Remede : on verifie
     desormais le contenu REEL du bouton a chaque appel (nos deux spans, rien
     d'autre) et on reconstruit si ce n'est pas le cas, avec un observateur dedie
     (garde anti-boucle) plus un setTimeout de secours au cas ou l'observateur ne
     se declenche jamais. */
  var ntyStickyObs = null;
  var ntyStickyWriting = false;
  var ntyStickyFallbackSet = false;
  function enhanceStickyAtc() {
    var bar = document.querySelector('[class*="mz-sticky-atc"]'); if (!bar) return;
    bar.classList.add('nty-sticky');
    var btn = bar.querySelector('[class*="mz-sticky-atc-btn"]'); if (!btn) return;
    var money = NTY_PROD.priceMoney || '';
    var expectedChildren = money ? 2 : 1;
    var c0 = btn.children[0], c1 = btn.children[1];
    /* 18/09/2026 : le prix affiche peut etre celui d'un PACK (2 ou 3 pieces, ecrit par sections/almea-com-packs dans
       .nty-sticky-price). Exiger « texte === prix unitaire » faisait REBATIR le bouton a chaque changement de pack :
       216,59 € ecrit puis 113,99 € remis 1 ms plus tard (« quand on change de pack ca bug un peu », Lancelot).
       Propre = nos deux spans, et le span prix contient un montant ; la valeur elle-meme n'est pas contestee. */
    var isClean = btn.children.length === expectedChildren &&
      c0 && c0.classList.contains('nty-sticky-label') &&
      (!money || (c1 && c1.classList.contains('nty-sticky-price') && /\d/.test(c1.textContent || '')));
    if (!isClean) {
      ntyStickyWriting = true;
      btn.textContent = '';
      var label = document.createElement('span'); label.className = 'nty-sticky-label'; label.textContent = 'Add to basket'; btn.appendChild(label);
      /* 03/09 : plus de tiret « — » devant le prix (demande de Lancelot, et regle CLAUDE.md §7 :
         jamais de tiret cadratin dans un texte publie). L'espace vient de la CSS (.nty-sticky-price). */
      if (money) { var sep = document.createElement('span'); sep.className = 'nty-sticky-price'; sep.textContent = money; btn.appendChild(sep); }
      btn.dataset.ntyLabel = '1';
      ntyStickyWriting = false;
    }
    if (!ntyStickyObs) {
      ntyStickyObs = new MutationObserver(function () {
        if (ntyStickyWriting) return;
        try { enhanceStickyAtc(); } catch (e) {}
      });
      ntyStickyObs.observe(bar, { childList: true, subtree: true });
    }
    if (!ntyStickyFallbackSet) {
      ntyStickyFallbackSet = true;
      setTimeout(function () { try { enhanceStickyAtc(); } catch (e) {} }, 1500);
    }
  }

  function isBrightBlue(rgb) {
    if (!rgb) return false; var m = rgb.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i); if (!m) return false;
    var r = +m[1], g = +m[2], b = +m[3]; return r < 60 && g >= 90 && g <= 150 && b > 200;
  }
  /* 09/09 PERF : cette fonction lit getComputedStyle sur CHAQUE noeud de la
     section. C'est la passe la plus chere du fichier. Elle etait rejouee a
     chaque run(), donc a chaque mutation du body relayee par l'observateur
     global : c'est ce qui faisait sauter les puces du carrousel et arriver les
     blocs en retard des qu'une couche ecrivait dans le DOM. Une passe au
     premier rendu et une au load suffisent : les couleurs d'origine ne
     changent plus apres. */
  var ntyHarmonizeCount = 0;
  function harmonizeColors() {
    return; /* 30/09 perf : vérifié sur la fiche (téléphone + ordinateur) : AUCUN élément bleu à repeindre. Cette passe lisait le style calculé de chaque élément de la section 2 fois pendant le chargement. RETOUR : retirer ce return. */
    if (ntyHarmonizeCount >= 2) return;
    ntyHarmonizeCount++;
    var section = document.querySelector('[class*="z-pageproduirgong"]') || document.querySelector('[class*="mz-product"]') || document.body; if (!section) return;
    var nodes = section.querySelectorAll('*');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.matches && (el.matches('[class*="mz-color-swatch"]') || el.closest('[class*="mz-color-swatch"]') || el.tagName === 'IMG' || el.tagName === 'PICTURE' || el.tagName === 'SOURCE')) { continue; }
      var cs = window.getComputedStyle(el);
      if (isBrightBlue(cs.backgroundColor)) { el.style.setProperty('background-color', NTY_ACCENT, 'important'); el.style.setProperty('background', NTY_ACCENT, 'important'); }
      if (isBrightBlue(cs.borderTopColor) || isBrightBlue(cs.borderBottomColor) || isBrightBlue(cs.borderLeftColor) || isBrightBlue(cs.borderRightColor)) { el.style.setProperty('border-color', NTY_ACCENT, 'important'); }
      if (isBrightBlue(cs.color)) { el.style.setProperty('color', NTY_ACCENT, 'important'); }
    }
  }

  function run() {
    try { enhanceGallery(); } catch (e) {}
    try { enhanceSwatches(); } catch (e) {}
    try { bindSwatchImageSwap(); } catch (e) {}
    try { enhanceSize(); } catch (e) {}
    try { enhancePromoBadge(); } catch (e) {}
    try { enhanceReviewsLine(); } catch (e) {}
    try { enhanceFeaturesBar(); } catch (e) {}
    /* 18/09/2026 : Description et Avis « Nautiya » ne sont PLUS construits. Ils sont masques sans exception sur la fiche
       par assets/almea-commercial.css (#mz-product-description / #nty-reviews en display:none, charge par 7 sections du
       gabarit) : on batissait 381 px de bloc visible a l'apparition de la fiche, effaces 1,5 s plus tard quand cette CSS
       arrivait — un saut pour rien. Les fonctions restent dans le fichier (rien d'autre ne les appelle). */
    try { enhanceStickyAtc(); } catch (e) {}
    try { harmonizeColors(); } catch (e) {}
  }

  /* 2026-08-16 : execution IMMEDIATE. Ce script est clone en fin de <body>
     (layout/theme.liquid) : toutes ses ancres existent deja au moment ou il
     s'execute. Attendre DOMContentLoaded faisait construire Description /
     Avis / miniatures APRES le premier rendu (sections qui « sautent »).
     run() est idempotent (gardes dataset.* et getElementById partout), les
     rappels DOMContentLoaded + load restent donc en simple filet de securite.
     Sauvegarde avant modification :
     assets/bak-20260816-nautiya-product-enhance.liquid.txt */
  run();
  window.__ntyRun = run; /* 30/09 perf mobile : rappelé en fin de section produit (script lu désormais juste après le prix) */
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); }
  window.addEventListener('load', run);

  /* 09/09 PERF : l'observateur global relancait run() 200 ms apres CHAQUE
     mutation du body, y compris celles que nos propres couches venaient
     d'ecrire (barre sticky, pop-up, etc.). Resultat : une reaction en chaine,
     chaque nouvelle couche ajoutant des passes completes. On ignore desormais
     les mutations qui viennent de nos propres elements, et on laisse un peu
     plus d'air au navigateur (400 ms). */
  var pending = null;
  function mutationANous(m) {
    var n = m.target;
    while (n && n !== document.body) {
      var c = (n.className && typeof n.className === 'string') ? n.className : '';
      var id = n.id || '';
      if (/nty-sticky|mz-sticky-atc/.test(c)) return true;
      if (/^almt|^almk|^nautiya-pop/.test(id)) return true;
      if (/almt-|almk-|nautiya-pop/.test(c)) return true;
      n = n.parentNode;
    }
    return false;
  }
  var obs = new MutationObserver(function (muts) {
    if (pending) return;
    var utile = false;
    for (var i = 0; i < muts.length; i++) { if (!mutationANous(muts[i])) { utile = true; break; } }
    if (!utile) return;
    pending = setTimeout(function () { pending = null; run(); }, 400);
  });
  if (document.body) { obs.observe(document.body, { childList: true, subtree: true }); }

  window.addEventListener('resize', function () { if (MOBILE()) run(); });
})();
